import React from 'react'
import PropTypes from 'prop-types'
import { QPMInfoContainer, QPMText } from './QPMInfo.style'

const QPMInfo = ({ qpmText }) => (
  <QPMInfoContainer>
    <QPMText>{qpmText}</QPMText>
  </QPMInfoContainer>
)

QPMInfo.propTypes = {
  qpmText: PropTypes.string.isRequired,
  compact: PropTypes.bool,
}

export default QPMInfo
